import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8de8b74867a3b99/components/forms/ContactForm.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8de8b74867a3b99/components/ui/Container.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de8b74867a3b99/app/[locale]/contact/contact.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["GoogleMapLazy"] */ "/tmp/8de8b74867a3b99/components/ui/GoogleMapLazy.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8de8b74867a3b99/components/ui/Section.module.css");
